import React from 'react';
import { render, fireEvent } from '@testing-library/react';
import Button from './button';

// Mock react-router withRouter
jest.mock('react-router', () => ({
    withRouter: (component) => component,
}));

// Mock react-native-web
jest.mock('react-native-web', () => ({
    Text: 'Text',
    View: 'View',
    Pressable: 'Pressable',
    StyleSheet: { create: (s) => s },
    Button: 'Button',
}));

describe('Button', () => {
    it('renders with text', () => {
        const { getByText } = render(<Button text="Click Me" clickEvent={() => {}} />);
        expect(getByText('Click Me')).toBeTruthy();
    });

    it('calls clickEvent when clicked', () => {
        const onClick = jest.fn();
        const { getByText } = render(<Button text="Click" clickEvent={onClick} />);
        fireEvent.click(getByText('Click'));
        expect(onClick).toHaveBeenCalledTimes(1);
    });

    it('does not call clickEvent when disabled', () => {
        const onClick = jest.fn();
        const { getByText } = render(<Button text="Click" clickEvent={onClick} disabled={true} />);
        fireEvent.click(getByText('Click'));
        expect(onClick).not.toHaveBeenCalled();
    });

    it('renders with icon', () => {
        const MockIcon = (props) => <svg data-testid="icon" {...props} />;
        const { getByTestId } = render(<Button text="With Icon" icon={MockIcon} clickEvent={() => {}} />);
        expect(getByTestId('icon')).toBeTruthy();
    });

    it('applies disabled styling', () => {
        const { container } = render(<Button text="Disabled" clickEvent={() => {}} disabled={true} />);
        expect(container.firstChild.className).toContain('opacity-50');
    });
});
